import React from "react";

const NutritionCard = ({
  calories,
  fat,
  protein,
  carbohydrates,
  sugar,
  fiber,
}) => {
  const nutritionData = [
    { label: "السعرات الحرارية", value: calories, unit: "kcal" },
    { label: "الدهون", value: fat, unit: "g" },
    { label: "البروتين", value: protein, unit: "g" },
    { label: "الكربوهيدرات", value: carbohydrates, unit: "g" },
    { label: "السكر", value: sugar, unit: "g" },
    { label: "الألياف", value: fiber, unit: "g" },
  ];
  return (
    <div className="card rounded-3">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="font16">القيم الغذائية</h4>
          {/* <button className="btn btn-primary">تعديل القيم</button> */}
        </div>

        <div className="row mt-2 g-3">
          {nutritionData.map((item, index) => (
            <div className=" col-4 " key={index}>
              <div className="bg-neutral-100 rounded-3 p-2 ">
                <h5 className="desc m-0 text-center">{item.label}</h5>
                <span className="font14 font700 d-block text-center">
                  {item.value} {item.unit}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NutritionCard;
